<template>
	<UITopHeading>Anfahrt</UITopHeading>
	<div class="container flex flex-col">
		<SharedTheArrival />
	</div>
</template>

<script lang="ts" setup>
useSeoMeta({
	title: 'Anfahrt',
	ogTitle: 'Anfahrt',
	twitterTitle: 'Anfahrt',
	description: 'Anfahrt zum Propellerfestival mit Adresse und Karte.',
	ogDescription: 'Anfahrt zum Propellerfestival mit Adresse und Karte.',
	twitterDescription: 'Anfahrt zum Propellerfestival mit Adresse und Karte.',
	ogUrl: 'https://propellerfestival.de/anfahrt',
})
</script>

<style></style>
